import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import PapperBlock from '../../../components/PapperBlock';
import SEOForm from '../SEOForm';
import { getSeoEmceesById, updateSeoEmceesById } from '../requests';
import { SEOIcon } from '../../../constants/icons';

export default function UpdateSeoEmcees() {
  const [data, setData] = useState({});
  const [loaded, setLoaded] = useState(false);
  const params = useParams();
  const { id } = params;
  async function processingRequest() {
    setData((await getSeoEmceesById(id)).data);
    setLoaded(true);
  }
  useEffect(() => {
    processingRequest();
  }, [loaded]);

  return (
    <PapperBlock title="Обновить SEO новости" icon={<SEOIcon />}>
      {loaded && (
        <SEOForm submitHandler={updateSeoEmceesById} data={data} submitButton />
      )}
    </PapperBlock>
  );
}
